import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { initializeApp } from "firebase/app";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import BranchSignupSteps from "./app/auth/branchSignupSteps";
import SignupSteps from "./app/auth/signupSteps";
import ClientCustomerSupport from "./app/clients/customorSupport";
import AllNotification from "./app/clients/notification";
import ChatBooking from "./components/chatBooking";
import { useBranches } from "./hooks/branch";
import { AuthRoutes, ClientRoutes, landingPageRoutes } from "./routes";
import { AuthLayout } from "./routes/Authlayout";
import { ProtectedLayout } from "./routes/ProtectedLayout";
import theme from "./theme";
import AccountDeletionForm from "./app/landingPages/accountDelete";

const firebaseConfig = {
  apiKey: "AIzaSyAB4876SVTJI-rwPDl4es0ZhIZgPF8lkOo",
  authDomain: "loba-business.firebaseapp.com",
  projectId: "loba-business",
  storageBucket: "loba-business.appspot.com",
  messagingSenderId: "243702147645",
  appId: "1:243702147645:web:236f4783fa50f3092c1854",
};

const app = initializeApp(firebaseConfig);

function App() {
  const { fetchBranches } = useBranches();
  const { branchesByBusiness } = useSelector((state) => state.branchSlices);
  const [routeData, setRouteData] = useState([]);
  const { user } = useSelector((state) => state.user);
  const { userRoutes } = useSelector((state) => state.routes);

  useEffect(() => {
    if (branchesByBusiness?.length === 0) {
      fetchBranches();
    }
  }, []);

  useEffect(() => {
    fetchBranches();
    if (user?.role === "business") {
      setRouteData(ClientRoutes);
    } else {
      const tempArr = userRoutes?.map((item) => {
        const route = ClientRoutes.find((route) => route.id === item?.id);
        return route;
      });
      setRouteData(tempArr);
    }
  }, [user, userRoutes]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <Routes>
          {landingPageRoutes.map(({ component: Component, path, id }) => {
            return <Route key={id} path={path} element={Component} />;
          })}
          <Route element={<AuthLayout />}>
            {AuthRoutes.map(({ component: Component, path, id }) => {
              return <Route key={id} path={path} element={Component} />;
            })}
          </Route>
          <Route path="/dashboard" element={<ProtectedLayout />}>
            {routeData?.map(({ component: Component, path, id }) => (
              <Route key={id} path={path} element={Component} />
            ))}
            <Route
              path={"/dashboard/customer-support"}
              element={<ClientCustomerSupport />}
            />
            <Route path={"/dashboard/booking"} element={<ChatBooking />} />
            <Route
              path={"/dashboard/all-notifications"}
              element={<AllNotification />}
            />
          </Route>
          <Route path={"/BranchSignupSteps"} element={<BranchSignupSteps />} />
          <Route path={"/profile-update/steps"} element={<SignupSteps />} />
          <Route path={"/account-delete"} element={<AccountDeletionForm />} />
        </Routes>
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
